import { createUseStyles } from 'react-jss';
import { Texts } from '@picsart/cascade';

const useStyles = createUseStyles({
  iconSizeSmall: {
    fill: Texts.base,
    cursor: 'pointer',
  },
  cursorPointer: {
    cursor: 'pointer',
  },
  iconNone: {
    fill: Texts.base,
    cursor: 'pointer',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  crossIcon: {
    position: 'absolute',
    fill: Texts.tint3,
    cursor: 'pointer',
    top: 0,
    right: 0,
    zIndex: 1,
  },
  disabledState: {
    opacity: '32%',
    pointerEvents: 'none',
  },
});

export default useStyles;
